var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAi = function SvgAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "illus-clr-2",
    d: "M16.875 0H1.125C.506 0 0 .506 0 1.125v15.75C0 17.494.506 18 1.125 18h15.75c.619 0 1.125-.506 1.125-1.125V1.125C18 .506 17.494 0 16.875 0ZM9.844 13.5 9 11.25H5.625l-.844 2.25H3.375l3.24-8.629.135-.371h1.125l.146.371L11.25 13.5H9.844Zm3.757-.034h-1.226V4.5h1.226v8.966Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "illus-clr-2",
    d: "M6.053 10.125h2.52L7.313 6.75l-1.26 3.375Z"
  })));
};
export default SvgAi;